import { Link } from "react-router-dom";
import { useUser } from "../../auth/useUser";
import { Header } from "../../components/Header";

// To wire: add the route in App.tsx as
//   <Route path="/legal/terms" element={<Terms />} />
// Public — no RequireAuth wrapper.
export function Terms() {
  const { data: user } = useUser();

  return (
    <div className="min-h-screen flex flex-col">
      {user ? (
        <Header
          user={user}
          breadcrumb={
            <>
              <span className="text-ink-600">/</span>
              <span className="font-mono text-ink-300">legal · terms</span>
            </>
          }
        />
      ) : (
        <PublicHeader title="Legal · Terms" />
      )}

      <main className="flex-1 max-w-6xl mx-auto w-full px-4 sm:px-8 py-16">
        {/* Long-form policy text reads better at ~2xl; outer max-w-6xl
            keeps chrome aligned with the rest of the app. */}
        <div className="max-w-2xl animate-fade-in">
          <p className="font-mono text-xs text-ink-400 tracking-widest uppercase mb-3">
            Legal
          </p>
          <h1 className="text-display font-medium text-ink-50 tracking-tightest">
            Terms
          </h1>
          <p className="mt-6 text-[15px] text-ink-200 leading-[1.7]">
            Terms of service coming soon.
          </p>

          <p className="mt-10 text-xs font-mono text-ink-500">
            <Link to="/" className="hover:text-ink-200 transition-colors">
              ← back
            </Link>
          </p>
        </div>
      </main>
    </div>
  );
}

function PublicHeader({ title }: { title: string }) {
  return (
    <header className="border-b border-ink-800 bg-ink-950/70 backdrop-blur-sm sticky top-0 z-10">
      <div className="max-w-6xl mx-auto px-4 sm:px-8 h-14 flex items-center gap-4 text-xs">
        <Link to="/" className="flex items-center gap-2">
          <div className="h-1.5 w-1.5 rounded-full bg-accent" />
          <span className="font-mono text-xs text-ink-200 tracking-widest uppercase">
            Eminity
          </span>
        </Link>
        <span className="text-ink-600">/</span>
        <span className="font-mono text-ink-300">{title}</span>
      </div>
    </header>
  );
}
